import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as EmailVerificationIlustration } from "../assets/images/email-verification-ilustration.svg";
import Link from "../components/Link/Link";
import Paragraph from "../components/paragraph/Paragraph";
import Steps from "../components/steps/Steps";
import { getAuthRoute } from "../constants/routes";

const RegisterSuccessfully = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  return (
    <div className="success">
      <Steps steps={4} activeStep={2} />
      <div className="success_page">
        <EmailVerificationIlustration className="hover-float" />
        <div className="success_content">
          <h1>Potvrdite vašu email adresu</h1>
          <div className="success_text">
            <Paragraph variant="p1">
              Ispratiti korake koje smo vam poslali na
            </Paragraph>
            {state?.email && <Paragraph variant="p2">{state?.email}</Paragraph>}
          </div>
          <div className="success_link">
            <h3>Već ste potvrdili email?</h3>
            <Link
              label="Prijavi se"
              variant="primary"
              onClick={() => navigate(getAuthRoute("login"))}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterSuccessfully;
